import {IService} from "@/model/Service/Service"

export interface IHasServicesSelected {
    getServicesSelected(): IService[]
    getServicesSelectedMap(): Map<string, IService>
    addServiceSelected(service: IService): void
    removeServiceSelected(service: IService): void
    getSelectedServiceID(): string
}

function hasServices<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServicesSelected {
        private servicesSelected: IService[] = []
        private servicesSelectedMap: Map<string, IService> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getServicesSelected(): IService[] {
            return this.servicesSelected
        }
        public getSelectedServiceID(): string {
            return this.servicesSelected[0].getIdShort()
        }

        public getServicesSelectedMap(): Map<string, IService> {
            return this.servicesSelectedMap
        }
        public addServiceSelected(service: IService): void {
            if (this.servicesSelectedMap.has(service.getIdFull())) return
            this.servicesSelected.push(service)
            this.servicesSelectedMap.set(service.getIdFull(), service)
        }
        public removeServiceSelected(service: IService): void {
            if (!this.servicesSelectedMap.has(service.getIdFull())) return
            this.servicesSelected = this.servicesSelected.filter((existingService: IService) => existingService.getIdFull() !== service.getIdFull())
            this.servicesSelectedMap.delete(service.getIdFull())
        }
    };
}

export default hasServices